import { ApiError, isUserFacing, request } from '@/shared/api/client';
import { couponImageSrc } from '@/shared/lib/image';
import type { Coupon, CouponResult } from './coupon';

type CouponDetailResponseDto = {
  productName: string;
  brandName: string;
  couponNumber: string;
  numberType: 'BARCODE' | 'URL';
  imageUrl: string | null;
  validEndDate: string;
  storeInformation: string[];
  precautions: string[];
  restrictions: string[];
};

type CouponByCodeResponseDto = {
  coupon: CouponDetailResponseDto | null;
  redirectUrl: string | null;
  token?: string | null;
};

function toCoupon(dto: CouponDetailResponseDto, token: string | null | undefined): Coupon {
  return {
    image: dto.imageUrl,
    imageProxy: token ? couponImageSrc(token) : null,
    name: dto.productName,
    brand: dto.brandName,
    number: dto.couponNumber,
    numberType: dto.numberType,
    precaution: dto.precautions,
    restriction: dto.restrictions,
    store: dto.storeInformation,
    expired: dto.validEndDate.replaceAll('-', '.'),
  };
}

export async function find(code: string): Promise<CouponResult> {
  try {
    const dto = await request<CouponByCodeResponseDto>(`/coupons/by-code/${encodeURIComponent(code)}`);
    if (dto.coupon) return { status: 'ok', coupon: toCoupon(dto.coupon, dto.token) };
    if (dto.redirectUrl) return { status: 'unsupported' };
    return { status: 'error', message: '', show: false };
  } catch (error) {
    if (error instanceof ApiError && error.status >= 400) {
      const show = isUserFacing(error);
      return { status: 'error', message: show ? error.message : '', show };
    }
    throw error;
  }
}
